<template>
    <div class="products">
        <div v-if="loading" class="loading"></div>
        <div v-if="!tech">
            <div class="container">
                <div v-if="histories === null"><h4>Товары не найдены</h4></div>
                <table v-if="histories !== null" class="table table-hover">
                    <thead class="thead">
                    <tr>
                        <td class="text-center">Номер заказа</td>
                        <td class="text-center">Дата</td>
                        <td class="text-center">Сумма (тг)</td>

                    </tr>
                    </thead>

                    <tbody class="tbody">
                        <tr v-for="history in histories">
                            <td class="text-center"><router-link tag="a" :to="{name: 'HistorySingle', params: {order_number: history.order_number}}">{{ history.order_number}}</router-link></td>
                            <td class="text-center">{{ history.created_at}}</td>
                            <td class="text-center">{{ history.total_price | chunk }}</td>
    <!--                        <td class="text-center"><router-link tag="a" :to="{name: 'HistorySingle', params: {order_number: history.order_number}}"><i class="fa fa-eye" aria-hidden="true"></i></router-link></td>-->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else>
            <div class="text-center mt-5">Техничесике неполадки. Свяжитесь с менеджером: +7 747 717 60 60</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                histories: null,
                loading: false,
                tech: false
            }
        },

        mounted() {
            this.axios
                .post(this.axios.defaults.baseURL + 'check-issue', {
                    'selected': 'История'
                })
                .then(response => {
                    if(response.data.message == 'issued') {
                        this.tech = true
                    }
                })

            this.loading = true;
            this.axios
                .get(this.axios.defaults.baseURL + 'histories')
                .then(response => {
                    this.histories = response.data.histories;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true;
                }).finally(()=> {
                    this.loading = false
            })
        },
        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        },
    }
</script>

<style lang="scss">
    a{
        i{
            transition: all 150ms ease-in-out;
        }
        &:hover{
            i{
                color: dodgerblue;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/history/HistoryList.vue